import { ImportRequestLog } from "vamos/cockpit/model/odata/VamosModel";
import getText from "vamos/cockpit/base/handler/Text";
import TimeUtil from "vamos/cockpit/util/TimeUtil";
import ApiFileHandler from "vamos/cockpit/base/handler/ApiFileHandler";


export default class Service {
  static async downloadFile(importRequestLog: ImportRequestLog) {

    const date = TimeUtil.formatPattern(new Date(Date.parse(importRequestLog.Time)), "YYYYMMDD");

    await ApiFileHandler.downloadFileFromApi("/import/download/single",
      { guid: importRequestLog.Guid },
      `${importRequestLog.RequestNumber}_${date}`,
      "zip",
    );

  }

  public static async downloadFiles(guids: string[]) {
    const date = TimeUtil.formatPattern(new Date(), "YYYYMMDD");

    await ApiFileHandler.downloadFileFromApi("/import/download/multiple",
      { guids: guids },
      `${getText("RequestFiles")}_${date}`,
      "zip",
    );
  }
}